import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {
  transform(value: string|undefined): string {
    let percentage=0;
    if (value) {
      percentage = parseFloat(value) * 100;
    }
    return percentage + '%';
  }
}
